/**
 * @generated SignedSource<<b39e9cc994917492a40010d3be4ea8f9>>
 * @relayHash b3bfaa8702f12bec58baa784e70871d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b365ec8bc711a381c4df636ebec3a5dd40a502586b34f7dcad8604c08f63c3c9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
};
export type GoalPanelQuery$data = {
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly townsquare: {
    readonly goal: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTabs" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatus" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "ParentGoal" | "SubGoals">;
    } | null | undefined;
  } | null | undefined;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "ari"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v5/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "value"
},
v9 = [
  (v8/*: any*/),
  {
    "kind": "ScalarField",
    "name": "score"
  }
],
v10 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v11 = [
  (v8/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v14 = {
  "kind": "ScalarField",
  "name": "url"
},
v15 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v11/*: any*/)
},
v16 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v1/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "description"
},
v18 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v19 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v1/*: any*/)
  ]
},
v20 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v19/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            }
          ]
        }
      ]
    }
  ]
},
v21 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "GoalPanelTitleField"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalStatus"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalType"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalOwner"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalMetrics"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalTargetDate"
              },
              {
                "kind": "FragmentSpread",
                "name": "ParentGoal"
              },
              {
                "kind": "FragmentSpread",
                "name": "SubGoals"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalTags"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalFollowers"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalStartDate"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalPanelTabs"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalActions"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalTeams"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      },
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "concreteType": "TownsquareGoalIcon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "appearance"
                  }
                ]
              },
              (v2/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v11/*: any*/),
                        "type": "TownsquareGoalTypeCustomName"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "defaultValue"
                          }
                        ],
                        "type": "TownsquareLocalizationField"
                      }
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v6/*: any*/)
              },
              {
                "concreteType": "TownsquareGoalProgress",
                "kind": "LinkedField",
                "name": "progress",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/)
                            ]
                          },
                          (v1/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v2/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "concreteType": "MetricTargetConnection",
                    "kind": "LinkedField",
                    "name": "metricTargets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "MetricTargetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "MetricTarget",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "concreteType": "Metric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "uuid"
                                  },
                                  (v2/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "archived"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "externalEntityId"
                                  }
                                ]
                              },
                              {
                                "concreteType": "MetricValue",
                                "kind": "LinkedField",
                                "name": "snapshotValue",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v1/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "startValue"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "targetValue"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "targetDate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTargetDateRange",
                    "kind": "LinkedField",
                    "name": "dateRange",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "start"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "end"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "parentGoal",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v2/*: any*/),
                  (v16/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareTagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareTag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareUserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v1/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              (v18/*: any*/),
              (v17/*: any*/),
              (v20/*: any*/),
              {
                "concreteType": "TownsquareGoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "missedUpdate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "summary"
                          },
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v21/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v21/*: any*/)
                          },
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "isArchived"
              },
              {
                "concreteType": "TownsquareGoalTeamConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalTeamEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "smallAvatarImageUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b365ec8bc711a381c4df636ebec3a5dd40a502586b34f7dcad8604c08f63c3c9",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bbc5081b4f06abef2ae1b62f5ece9102";

export default node;
